import {Action} from 'redux'
import {actionTypes} from './constants'
import {OAuthClient, OAuthToken} from '../Model'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export interface IOAuthClientsState {
  clients: OAuthClient[]
  loading: boolean
  createLoading: boolean
  createSuccess: boolean
  createdClient: OAuthClient | null
  createError: any
  revokeSuccess: boolean
  deleteSuccess: boolean
  tokens: OAuthToken[]
  tokensLoading: boolean
}

const initialState: IOAuthClientsState = {
  clients: [],
  loading: false,
  createLoading: false,
  createSuccess: false,
  createdClient: null,
  createError: null,
  revokeSuccess: false,
  deleteSuccess: false,
  tokens: [],
  tokensLoading: false,
}

export const reducer = (
  state: IOAuthClientsState = initialState,
  action: ActionWithPayload<any>
): IOAuthClientsState => {
  switch (action.type) {
    // List
    case actionTypes.GET_OAUTH_CLIENTS_REQUEST:
      return {...state, loading: true}
    case actionTypes.GET_OAUTH_CLIENTS_SUCCESS:
      return {...state, clients: action.payload || [], loading: false}
    case actionTypes.GET_OAUTH_CLIENTS_FINISH:
      return {...state, loading: false}

    // Create
    case actionTypes.CREATE_OAUTH_CLIENT_REQUEST:
      return {...state, createLoading: true, createSuccess: false, createdClient: null, createError: null}
    case actionTypes.CREATE_OAUTH_CLIENT_SUCCESS:
      return {...state, createLoading: false, createSuccess: true, createdClient: action.payload || null}
    case actionTypes.CREATE_OAUTH_CLIENT_FINISH:
      return {
        ...state,
        createLoading: false,
        createError: action.payload
          ? action.payload?.response?.data ?? action.payload
          : null,
      }
    case actionTypes.CREATE_OAUTH_CLIENT_RESET:
      return {...state, createSuccess: false, createdClient: null, createError: null}

    // Revoke
    case actionTypes.REVOKE_OAUTH_CLIENT_REQUEST:
      return {...state, revokeSuccess: false}
    case actionTypes.REVOKE_OAUTH_CLIENT_SUCCESS:
      return {...state, revokeSuccess: true}
    case actionTypes.REVOKE_OAUTH_CLIENT_FINISH:
      return {...state, revokeSuccess: false}

    // Delete
    case actionTypes.DELETE_OAUTH_CLIENT_REQUEST:
      return {...state, deleteSuccess: false}
    case actionTypes.DELETE_OAUTH_CLIENT_SUCCESS:
      return {...state, deleteSuccess: true}
    case actionTypes.DELETE_OAUTH_CLIENT_FINISH:
      return {...state, deleteSuccess: false}

    // Tokens
    // Clear previous tokens immediately so the view drawer never shows a stale
    // client's tokens while the new client's tokens are loading.
    case actionTypes.GET_OAUTH_TOKENS_REQUEST:
      return {...state, tokensLoading: true, tokens: []}
    case actionTypes.GET_OAUTH_TOKENS_SUCCESS:
      return {...state, tokens: action.payload || [], tokensLoading: false}
    case actionTypes.GET_OAUTH_TOKENS_FINISH:
      return {...state, tokensLoading: false}

    default:
      return state
  }
}
